import dayjs from "dayjs";
import { TRACK_URL, CDVALET_BASE_URL } from "./constant";
import { getAccessToken } from "../auth";
import { apiFetch } from "../Components/ApiCall";

export const formatRating = (starRating, decimal = 1) => {
  if (starRating) {
    starRating = starRating.toString().replace("½", ".5");
    return Number(starRating).toFixed(decimal) || "0.0";
  }
  return "NR";
};

export const formatTerms = (showTerms) => {
  if (parseFloat(showTerms) === 0 || showTerms === "" || showTerms === null)
    return "NA";
  return isNaN(showTerms) ? showTerms : showTerms + " Mo";
};

export const formatNumber = (value) => {
  return Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+\b)/g, ",");
};

export const formatBalance = (value, field, className, withElement = true) => {
  if (value && (value !== "" || value !== "0")) {
    if (!withElement) return "$" + formatNumber(value);
    return (
      <span className={className}>
        <span>$</span>
        {formatNumber(value)}
      </span>
    );
  }
  if (!value && field === "minDeposit") {
    return "No Limit";
  }
  return "$ 0";
};

export const formateDate = (dateFort) => {
  return dayjs(dateFort).format("MM/DD/YYYY");
};

export const isNumberDecimal = (paramStr) => {
  const reg = /^\d+(\.\d{0,2})?$/;
  return reg.test(paramStr);
};

export const numberToLocalForm = (numberFrm) => {
  return numberFrm === "" || isNaN(numberFrm)
    ? ""
    : Number(numberFrm).toLocaleString();
};

export const removeCommaFromNumString = (str) => {
  if (typeof str === "number") {
    str = str.toString();
  }
  return str.replace(/,/g, "");
};

// Apply Now file
export const legalType = (value) => {
  const legalTypes = {
    bank: "Member FDIC",
    cu: "Insured by NCUA",
  };

  return legalTypes[value] || "";
};

export const redirectToNewTab = (newPageUrl = "") => {
  const element = document.getElementById("openNewTabAnchor");
  if (element) {
    element.href = newPageUrl;
    element.target = "_blank";
    element.rel = "noopener";
    element.click();
  }
};

export const isAlphaNumericWithSpace = (value) => {
  const reg = /^[A-Za-z0-9\s]+$/;
  return reg.test(value);
};

export const isEmail = (value) => {
  const mail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w{2,5}$/;
  return mail.test(value);
};

export const isNumber = (value) => {
  const reg = /^[0-9\b]+$/;
  return reg.test(value);
};

export const isValidationBasedOnType = (value, ValidationType) => {
  if (ValidationType === "require") {
    return value && value.trim() !== "";
  } else if (ValidationType === "phone") {
    return value.length <= 14 && value.length >= 10;
  } else if (ValidationType === "alphanumeric") {
    return isAlphaNumericWithSpace(value);
  } else if (ValidationType === "email") {
    return isEmail(value);
  } else if (ValidationType === "numeric") {
    return isNumber(value);
  }
};

export const formatNumberWithDec = (inputNumber) => {
  return Number(inputNumber)
    .toFixed(2)
    .replace(/\d{3}\./g, "$&");
};

export const formatPhoneNumber = (value) => {
  if (value?.length > 14) {
    value = value?.substr(value?.length - 14);
  }
  let newFormat = "";
  const cleaned = ("" + value).replace(/\D/g, "");
  for (let i = 0; i < cleaned.length; i++) {
    if (i === 0) {
      newFormat = "(";
    } else if (i === 3) {
      newFormat = newFormat + ")" + " ";
    } else if (i === 6) {
      newFormat = newFormat + "-";
    }
    newFormat = newFormat + cleaned[i];
  }
  return newFormat;
};

export async function clickTrack(
  data = {},
  redirectURL,
  isOpenNowEvent = false
) {
  const affiliateId = new URLSearchParams(window.location.search).get(
    "affiliateId"
  );
  const accessTokenObj = getAccessToken();
  const payload = {
    cd_id: data?._id || data?.cdId,
    redirect_url: redirectURL || data?.url,
    isOpenNowEvent,
    params:{
      cd_id: data?._id || data?.cdId,
      ...data,
    },
  };

  try {
    const response = await apiFetch(
      `/api/v1/track/click`,
      "POST",
      payload,
      {
        Origin: CDVALET_BASE_URL,
        Cookie: `affiliateId=${affiliateId}; refreshToken=${accessTokenObj?.refreshToken}`,
        refreshToken: accessTokenObj?.refreshToken,
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessTokenObj?.token}`,

      },
      TRACK_URL,
      { skipAuth: true, credentials: "include" }
    );

    return response;
  } catch (err) {
    console.log("error in click track", err);
  }
}
